import * as React from 'react';

function SvgCreditcard(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 9c0-.796.328-1.559.911-2.121A3.17 3.17 0 014.111 6H25.89a3.17 3.17 0 012.2.879C28.672 7.44 29 8.204 29 9v12c0 .796-.328 1.559-.911 2.121a3.17 3.17 0 01-2.2.879H4.11a3.17 3.17 0 01-2.2-.879A2.947 2.947 0 011 21V9z"
        fill="#E6E9EB"
      />
      <path d="M5.296 18h20.408v2H5.296v-2z" fill="#B9C4C9" />
      <path
        d="M8.519 10H6.37c-.593 0-1.074.448-1.074 1v2c0 .552.481 1 1.074 1H8.52c.593 0 1.074-.448 1.074-1v-2c0-.552-.481-1-1.074-1z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgCreditcard;
